import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import PlusCardButton from "../../../PlusCardButton/PlusCardButton";

interface Props {
  onClick: () => void;
}

const AddNewMedicationButton = ({ onClick }: Props) => {
  return <PlusCardButton value={translate(STRINGS.ADD_NEW_MEDICATION)} onClick={onClick} />;
};

export default React.memo(AddNewMedicationButton);
